import type { ConversationItemParts } from 'owa-mail-store';
import mailStore from 'owa-mail-store/lib/store/Store';

export default function getConversationNodeIds(conversationId: string): string[] {
    const conversationItemParts: ConversationItemParts | undefined =
        mailStore.conversations.get(conversationId);
    return conversationItemParts?.conversationNodeIds || [];
}
